import colton from "../images/image-colton.jpg";
import irene from "../images/image-irene.jpg";
import anne from "../images/image-anne.jpg";

const customerTestimonial = [
    {
        id: 0,
        avatar: colton,
        name: "Colton Smith",
        status: "Verified Buyer",
        testimonial:
            "We needed the same printed designd as the one we had ordered a week prior. Not only did they find the originas order, but we also received it in time. Excellent!",
        position: 0,
    },
    {
        id: 1,
        avatar: irene,
        name: "Irene Roberts",
        status: "Verified Buyer",
        testimonial:
            "Customer service is always excellent and very quick tun¿rn around. Completely deligthed wuth the simplicity of the purchase and the speed of delivery.",
        position: 30,
    },
    {
        id: 2,
        avatar: anne,
        name: "Anne Wallace",
        status: "Verified Buyer",
        testimonial:
            "Put an order with this company ans can only prause them for th very high standard. Will definitely use them again and recommend then to everyone!",
        position: 60,
    },
];

export default customerTestimonial;
